/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import qs from 'qs';
import Request from '../request';

export const getListProduct = (params) => {
  const formattedParams = qs.stringify(params, { arrayFormat: 'repeat' });
  return Request.call({
    url: `/micro/products${formattedParams ? `?${formattedParams}` : ''}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const getProduct = (id) => {
  return Request.call({
    url: `/micro/products/${id}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
